import {jsx} from 'panel';

import {IconSizeType} from 'common/constants';
import {UserIconEl} from 'common/widgets/user-icon';
import type {CellRenderContext, TableColumn, TableRow} from 'common/components/table/types';
import {FieldWithMatches} from 'common/components/table/cell-mixins';
import {getEntityCreatorDisplayName} from 'common/report/stores/user-details';

/**
 * NOTE: this cell mixin assumes a userDetailsStore subscription somehwere in the consumer app.
 */
function CellTypeUser({item, context}: {item: TableRow; context: CellRenderContext}) {
  return (
    <>
      <UserIconEl
        attrs={{
          id: item.user_id || item.userId || item.id,
          name: context.label,
          'disable-tooltip': true,
          size: IconSizeType.Medium,
          email: item.userEmail,
        }}
      />
      <div sel='.mp-table-cell-type-user-label'>
        <FieldWithMatches item={item} context={context} />
      </div>
    </>
  );
}

export const userCellRenderer: TableColumn['cellRenderer'] = (row, context) => {
  return <CellTypeUser item={row} context={context} />;
};

export const userCellLabelTransform: TableColumn['labelTransform'] = (row, label) => {
  return getEntityCreatorDisplayName(row.userEmail, row[label]);
};

export const userColumnProps: Partial<TableColumn> = {
  cellRenderer: userCellRenderer,
  labelTransform: userCellLabelTransform,
  type: `user`,
};
